import React, {Component} from 'react';
import {connect} from 'react-redux';
import {browserHistory, Link} from 'react-router';
import {getAnimalsProtectora, loadInfoProtectoraDetail} from "../../../AnimalList/actions/actionsAnimalList";
import {
    PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN,
} from "../../../../App/RouterAdopta";
import {checkIsLogin} from "../../actions/actionsAdmin";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {sendEvent} from "../../../../analytics/analitycs"


class PanelServicios extends Component {

    constructor(props) {
        super(props);


        this.animalsControl = "animalsProtectora"
        this.props.isLogin();
        this.onClickBtnWA = this.onClickBtnWA.bind(this);

    }

    render() {
    
        return (
            <div className="col-lg-4">
                <div
                    className="listing-houses__item">
                    <div className={"listing-houses__item-image"} onClick={this.showData}
                         data-id={"unid"}>
                        <LazyLoadImage threshold={150}
                            className="img-fluid img-servicio"
                            alt={`servicio ${this.props.titulo} Adopta un Animal`}
                            src={this.props.img_src}
                            width="398" height="298"
                        />
                    </div>

                    <div className="item-plan">
                        <h3 className="text-center">{this.props.titulo}</h3>
                        <p className="price text-center">- {this.props.precio} -</p>
                        <br/>
                        <p className="descricpion-servicio">
                            {this.props.descripcion}
                        </p>
                        {/*<div className="pt-1 main-link">*/}
                        {/*    <a href="https://generatorlanding.com/docs/AsesoriaPrivada_GeneratorLanding.pdf"*/}
                        {/*       target="_blank" className="info-btn-servicios">*/}
                        {/*        <span className="las la-2x la-info-circle"/> Ver servicio*/}
                        {/*    </a>*/}
                        {/*</div>*/}
                        <div className="pt-1 main-link">
                            <Link to={"https://api.whatsapp.com/send?phone=++34699252717&text=Hola,%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20servicio%20*" + this.props.titulo + "*"}
                               target="_blank" rel="nofollow" className="main-btn-servicios" onClick={this.onClickBtnWA}>
                                <span className="lab la-2x la-whatsapp"/> Contactar ahora
                            </Link>
                        </div>
                        {/*<img src="https://generatorlanding.com/elements/compra-segura.png" alt=""/>*/}
                        {/*<p className="smallText"><font>*/}
                        {/*<p className="smallText" style="font-size: 14px;"><font*/}
                        {/*<font>Precio especial para usuarios de Adopta un Animal</font></font>*/}
                        {/*</p>*/}

                    </div>

                </div>
            </div>
        );
    }


    onClickBtnWA() {
        //console.log("PanelServicios::onClickBtnWA()");
        sendEvent('click',
            'app_boton_wa_servicio_' + this.props.titulo.replace(/ /g, "_"),
            {
                id_protectora: this.props.access.id, email_protectora: this.props.access.user,
                hostname: window.location.hostname, pathname: window.location.pathname, href: window.location.href
            })
    }


    componentWillMount() {
        if (!this.props.access.isLogin) {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
        } else {
            this.props.loadInfoProtectoraDetail(this.props.access.id, this.animalsControl, "completa");
            this.props.getAnimalsProtectora({varsData: {id_protectora: this.props.access.id}});
        }

        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({
                scrollTop: element.offset().top
            }, 0);
        }

    }

    componentDidMount() {


    }

}

function mapStateToProps(state) {
    return {
        access: state.access,
        showHead: state.structureControl.showHead,
        animalDetailProtectora: state.animalDetailProtectora,
        animals: state.animalsProtectora.list
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    isLogin: checkIsLogin,
    loadInfoProtectoraDetail,
    getAnimalsProtectora
})(PanelServicios)
